import { Col, Radio, Row } from 'antd';
import IpsDTCommentsIcon from 'components/CommentsIcon/IpsDTCommentsIcon';
import React, { useState } from 'react';
import { getToolTipFormatedStrForIPSDT } from './toolTipHelper';
import { Divider } from 'antd';
import {Form} from "react-bootstrap";
import { updateDataTrackerProject } from 'api';
import ConfirmDialog from '../CommonComponent/DialogBox/ConfirmDialogBox';
import {
  isIPSAdministrator, isIPSDataCreatorOrAdministrator
} from 'utils/UserInfo';

import { projectStatusDisplayMap } from 'components/ProjectStatusMap';
import IpsStationSection from './IpsStationSection';
import IpsExlamationIcon from 'components/ExclamationIcon/IpsExlamationIcon';
import { directToProject } from 'utils/Dashboard';

function ProjectDetails({
  project,
  
  commonComments,
  history,
  context,
  handleProjectDetailUpdate,
  setCurrentProject,
  isReadOnly,
}) {
  const projTypeArray = ['Capital','Legacy','NSW','Break/Fix','Emergency Restoration'];

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [confirmDialogDetails, setConfirmDialogDetails] = useState({});

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleProjectStatusChange = async (project) => {
    let projectInfo = {
      bpid: project.bpid,
      workOrder: project.workOrder,
      stationName: project.stationName,
    };

    await updateDataTrackerProject(projectInfo);

    history.push(`/dashboard/datatracker_na`);
    context.setProjectTab('datatracker_na');
    setIsModalOpen(false);
  };
  const handleProjectUndoComplete = async () => {
    await handleProjectDetailUpdate('N', 'IPS_COMPL_FLAG', 'string');
    history.push(`/dashboard/datatracker_progress`);
    context.setProjectTab('datatracker_progress');
    setIsModalOpen(false);
  };
  const handleProjectMoveToNA = () => {
    setConfirmDialogDetails({
      title: `Do you want to set ${project.stationName} to Checklist N/A?`,
      confirmButtonName: 'Yes,Move N/A',
      handleSubmit: handleProjectStatusChange,
    });
    setIsModalOpen(true);
  };
  const handleUndoCompleteProject = () => {
    setConfirmDialogDetails({
      title: `Do you want to Undo  ${project.stationName} Complete Project?`,
      confirmButtonName: 'Yes,Undo',
      handleSubmit: handleProjectUndoComplete,
    });
    setIsModalOpen(true);
  };

// FOR PROJECT ON HOLD
  
  const handleProjectOnHold = (e) => {
    let value = e.target.value;

    
    handleProjectDetailUpdate(
      value,
      'PROJECT_HOLD_FLAG',
      'string'
    ).then((response) => {
      
      if (value === 'Y') {
     
        history.push(`/dashboard/datatracker_hold`);
        context.setProjectTab('datatracker_hold');
  
      } else {
        
        history.push(`/dashboard/datatracker_progress`);
        context.setProjectTab('datatracker_progress');
      }

    })

    


  }

  return (
    <>
      <div className='border-container'>
        <section className='padding-container'>
          <Row justify='space-between' align='middle'>
            <Col>
              <Col>
                {' '}
                <Col>
                  <span className='checklist-detail'>Checklist ID :</span>
                  {project.tclProjectId}
                </Col>
              </Col>
              <Col>
                <Col>
                  <span className='checklist-detail'>Checklist Status :</span>
                  {projectStatusDisplayMap[project.projectStatus]}
                </Col>
              </Col>
            </Col>
            <Col>
              <Row justify='space-between'>
                <Col className='checklist-detail'>Project Hold :</Col>
                <Row>
                  <Radio.Group
                    style={{ display: 'inline-flex' }}
                    id={'removal-check'}
                    defaultValue={'N'}
                    options={[
                      {
                        label: 'Yes',
                        value: 'Y',
                        id: 'removal-check',
                      },
                      { label: 'No', value: 'N' },
                    ]}
                    // onChange={(e) => {
                    //   let value = e.target.value;
                    //   handleProjectDetailUpdate(
                    //     value,
                    //     'PROJECT_HOLD_FLAG',
                    //     'string'
                    //   );
                    // }}
                    onChange={handleProjectOnHold}
                    value={project?.projectHoldFlag}
                    disabled={isReadOnly}
                  />
                  {project && project.projectHoldChangedDate && (
                    <Col>{`${project.projectHoldChangedUser}  ${project.projectHoldChangedDate}`}</Col>
                  )}
                </Row>
              </Row>
            </Col>
            <Row justify='space-between' align='middle'>
              {isIPSDataCreatorOrAdministrator() && (
                <>
                  {
                    (
                      project.allIPSComplFlag !== 'Y' && <Col>
                        <button
                          type='button'
                          className='w3-button btn-primary '
                          disabled={!isIPSDataCreatorOrAdministrator()}
                          onClick={() => handleProjectMoveToNA()}
                        >
                          Data Tracker N/A
                        </button>
                      </Col>
                    )}

                  <ConfirmDialog
                    show={isModalOpen}
                    title={confirmDialogDetails.title}
                    handleCancel={handleCancel}
                    submitFunctionArgs={project}
                    handleSubmit={confirmDialogDetails.handleSubmit}
                    confirmButtonName={confirmDialogDetails.confirmButtonName}
                    cancelButtonName={'No,Cancel'}
                  />
                </>
              )}
              <Col>
                {project.manual && 
                  <IpsExlamationIcon
                    project={project}
                  />
                }
              </Col>
              <Col>
                <IpsDTCommentsIcon
                  project={project}
                  commentGroup={'COMMON'}
                  comments={commonComments}
                  view={'projectDetail'}
                  phase={0}
                />
              </Col>
            </Row>
          </Row>
        </section>
        <IpsStationSection
          project={project}
          // project={project}

          handleProjectDetailUpdate={handleProjectDetailUpdate}

          isReadOnly={isReadOnly}
        />
        <Divider className='hr-border' />
        <section className='padding-container'>
          <Row>
            <Col
              xs={{
                span: 24,
              }}
              sm={{
                span: 24,
              }}
              md={{
                span: 24,
              }}
              lg={{
                span: 12,
              }}
              xxl={{
                span: 12,
              }}
            >
              <Row className='spacing-bottom'>
                <Col
                  className='key-title'
                  xs={{
                    span: 5,
                  }}
                  sm={{
                    span: 5,
                  }}
                  md={{
                    span: 5,
                  }}
                  lg={{
                    span: 6,
                  }}
                  xxl={{
                    span: 4,
                  }}
                >
                  Ecosys Station Name :
                </Col>
                <Col>{project.ecosysStation}</Col>
              </Row>
              <Row className='spacing-bottom'>
                <Col
                  className='key-title'
                  xs={{
                    span: 5,
                  }}
                  sm={{
                    span: 5,
                  }}
                  md={{
                    span: 5,
                  }}
                  lg={{
                    span: 6,
                  }}
                  xxl={{
                    span: 4,
                  }}
                >
                  Project Description :
                </Col>
                <Col>{project.projectDescription}</Col>
              </Row>

              <Row className='spacing-bottom'>
                <Col
                  className='key-title'
                  xs={{
                    span: 5,
                  }}
                  sm={{
                    span: 5,
                  }}
                  md={{
                    span: 5,
                  }}
                  lg={{
                    span: 6,
                  }}
                  xxl={{
                    span: 4,
                  }}
                >
                  Project Type
                </Col>
                <Col>
                  <div className='section-container'>
                  <Form.Control as='select'
                  value={
                    project && project.projTypeDt
                      ? project.projTypeDt
                      : ''
                }
                onChange={(e) => {
                  handleProjectDetailUpdate(
                    e.target.value,
                    'proj_type_dt',
                    'string'
                  );
                }}
                disabled={isReadOnly}
              >
                <option value=''>Select</option>
                {projTypeArray?.map((projType, index) => (
                  <option value={projType} key={index}>
                    {projType}
                  </option>
                ))}
              </Form.Control>
                  </div>
                </Col>
              </Row>
            </Col>
            <Col
              xs={{
                span: 24,
              }}
              sm={{
                span: 24,
              }}
              md={{
                span: 24,
              }}
              lg={{
                span: 12,
              }}
              xxl={{
                span: 12,
              }}
            >
              <Row className='spacing-bottom'>
                <Col
                  className='key-title'
                  xs={{
                    span: 4,
                  }}
                  sm={{
                    span: 4,
                  }}
                  md={{
                    span: 5,
                  }}
                  lg={{
                    span: 4,
                  }}
                  xxl={{
                    span: 3,
                  }}
                >
                  Work Order :
                </Col>
                <Col>
                  {getToolTipFormatedStrForIPSDT('WO', project.workOrder, project)}
                </Col>
              </Row>

              <Row className='spacing-bottom'>
                <Col
                  className='key-title'
                  xs={{
                    span: 4,
                  }}
                  sm={{
                    span: 4,
                  }}
                  md={{
                    span: 5,
                  }}
                  lg={{
                    span: 4,
                  }}
                  xxl={{
                    span: 3,
                  }}
                >
                  BPID :
                </Col>
                <Col>{getToolTipFormatedStrForIPSDT('BPID', project.bpid, project)}</Col>
              </Row>

              <Row className='spacing-bottom'>
                <Col
                  className='key-title'
                  xs={{
                    span: 4,
                  }}
                  sm={{
                    span: 4,
                  }}
                  md={{
                    span: 5,
                  }}
                  lg={{
                    span: 4,
                  }}
                  xxl={{
                    span: 3,
                  }}
                >
                  MPID :
                </Col>
                <Col>{getToolTipFormatedStrForIPSDT('MPID', project.mpid, project)}</Col>
              </Row>
            </Col>
          </Row>
        </section>
        <Divider className='hr-border' />
        <section className='padding-container'>
          <Row>
            <Col
              xs={{
                span: 24,
              }}
              sm={{
                span: 24,
              }}
              md={{
                span: 24,
              }}
              lg={{
                span: 12,
              }}
              xxl={{
                span: 12,
              }}
            >
              <Row className='spacing-bottom'>
                <Col
                  className='key-title'
                  xs={{
                    span: 5,
                  }}
                  sm={{
                    span: 5,
                  }}
                  md={{
                    span: 5,
                  }}
                  lg={{
                    span: 6,
                  }}
                  xxl={{
                    span: 4,
                  }}
                >
                  State :
                </Col>
                <Col>{project.stationState}</Col>
              </Row>
              <Row className='spacing-bottom'>
                <Col
                  className='key-title'
                  xs={{
                    span: 5,
                  }}
                  sm={{
                    span: 5,
                  }}
                  md={{
                    span: 5,
                  }}
                  lg={{
                    span: 6,
                  }}
                  xxl={{
                    span: 4,
                  }}
                >
                  Station Region :
                </Col>
                <Col>{project.stationRegion}</Col>
              </Row>
              <Row className='spacing-bottom'>
                <Col
                  className='key-title'
                  xs={{
                    span: 5,
                  }}
                  sm={{
                    span: 5,
                  }}
                  md={{
                    span: 5,
                  }}
                  lg={{
                    span: 6,
                  }}
                  xxl={{
                    span: 4,
                  }}
                >
                  {' '}
                  TFS Station Area :
                </Col>
                <Col>{project.tfStationArea}</Col>
              </Row>
              <Row className='spacing-bottom'>
                <Col
                  className='key-title'
                  xs={{
                    span: 5,
                  }}
                  sm={{
                    span: 5,
                  }}
                  md={{
                    span: 5,
                  }}
                  lg={{
                    span: 6,
                  }}
                  xxl={{
                    span: 4,
                  }}
                >
                  TFS P&C Area :
                </Col>
                <Col>{project.pcArea} </Col>
              </Row>
            </Col>

            <Col
              xs={{
                span: 24,
              }}
              sm={{
                span: 24,
              }}
              md={{
                span: 24,
              }}
              lg={{
                span: 12,
              }}
              xxl={{
                span: 12,
              }}
            >
              <Row className='spacing-bottom'>
                <Col
                  className='key-title'
                  xs={{
                    span: 5,
                  }}
                  sm={{
                    span: 5,
                  }}
                  md={{
                    span: 5,
                  }}
                  lg={{
                    span: 7,
                  }}
                  xxl={{
                    span: 5,
                  }}
                >
                  Construction Start Date :
                </Col>
                <Col> {project.constructionStartDate}</Col>
              </Row>
              <Row className='spacing-bottom'>
                <Col
                  className='key-title'
                  xs={{
                    span: 5,
                  }}
                  sm={{
                    span: 5,
                  }}
                  md={{
                    span: 5,
                  }}
                  lg={{
                    span: 7,
                  }}
                  xxl={{
                    span: 5,
                  }}
                >
                  Checklist Release Date :
                </Col>
                <Col> {project.tclReleaseDate}</Col>
              </Row>
              <Row className='spacing-bottom'>
                <Col
                  className='key-title'
                  xs={{
                    span: 5,
                  }}
                  sm={{
                    span: 5,
                  }}
                  md={{
                    span: 5,
                  }}
                  lg={{
                    span: 7,
                  }}
                  xxl={{
                    span: 5,
                  }}
                >
                  In-Service Date :
                </Col>
                <Col> {project.inServiceDate}</Col>
              </Row>

              <Row className='spacing-bottom'>
                <Col
                  className='key-title'
                  xs={{
                    span: 5,
                  }}
                  sm={{
                    span: 5,
                  }}
                  md={{
                    span: 5,
                  }}
                  lg={{
                    span: 7,
                  }}
                  xxl={{
                    span: 5,
                  }}
                >
                  No of Assets :
                </Col>
                <Col> {project.noOfAssets} </Col>
              </Row>
            </Col>
          </Row>
        </section>

      </div>
    </>
  );
}

export default ProjectDetails;
